// src/components/AvailabilityHintPill.tsx
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { addDays } from "date-fns";
import { expandAvailability, type Interval } from "@/lib/availability";
import { summarizeAvailability } from "@/lib/availabilitySummary";
import { Badge } from "@/components/ui/badge";
import { Calendar } from "lucide-react";

export default function AvailabilityHintPill({ listingId }: { listingId: string }) {
  const rangeStart = new Date();
  const rangeEnd = addDays(rangeStart, 90);

  const { data } = useQuery({
    queryKey: ["availability", listingId, "hint"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("availability")
        .select("*")
        .eq("listing_id", listingId);
      if (error) throw error;
      return data ?? [];
    },
  });

  const hasRows = !!data?.length;
  if (!hasRows) return null;

  const windows: Interval[] = expandAvailability(data as any, rangeStart, rangeEnd);
  const { shortHint } = summarizeAvailability(windows, 30);

  return (
    <Badge variant="outline" className="text-xs">
      <Calendar className="h-3 w-3 mr-1" />
      {shortHint}
    </Badge>
  );
}
